import styled from "styled-components";
// linter is telling me that buttons are more accesible than links w/o hrefs
export default styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: ${(props) => props.color};
`;
